import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FormattedMessage, useIntl } from 'react-intl'
import { i18nMessages } from '../../Logic/CodeAccessible.i18n.Messages'
import { CapeeshColors } from '../../assets/ColorPalette'
import { formatHours, formatNormalizedAsPercent } from '../../Views/Private/CourseStatisticsConstants'

const useStyles = makeStyles(() => ({
    strip: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '12px',
        marginTop: '20px',
    },
    card: {
        flex: '1 1 160px',
        backgroundColor: CapeeshColors.OffWhite,
        borderRadius: '10px',
        padding: '16px',
        minWidth: '150px',
    },
    value: {
        fontFamily: 'Rubik',
        fontWeight: 500,
        fontSize: '24px',
        color: CapeeshColors.Gray900,
    },
    label: {
        fontFamily: 'Rubik',
        fontSize: '13px',
        color: CapeeshColors.Gray1,
        marginTop: '4px',
    },
}))

/**
 * Scope totals. Aggregate only - no cohort counts here, by design: a headline such as
 * "1 of 3 users below 60%" would identify someone in a small classroom.
 */
const CourseStatsHeadlineStrip = (props) => {
    const classes = useStyles()
    const intl = useIntl()

    const headline = props.headline
    if (!headline) {
        return null
    }

    const cards = [
        {
            // API field names keep the backend spelling: coursesInUse counts topics.
            key: 'topicsInUse',
            value: `${headline.coursesInUse} / ${headline.coursesInScope}`,
            label: intl.formatMessage(i18nMessages.courseStatisticsTopicsInUse),
        },
        {
            key: 'activeUsers',
            value: `${headline.activeUsers} / ${headline.usersInScope}`,
            label: intl.formatMessage(i18nMessages.courseStatisticsActiveUsers),
        },
        {
            key: 'lessonsPassed',
            value: headline.lessonsPassed,
            label: intl.formatMessage(i18nMessages.courseStatisticsLessonsPassed),
        },
        {
            key: 'hoursSpent',
            value: formatHours(headline.hoursSpent),
            label: intl.formatMessage(i18nMessages.courseStatisticsHoursSpent),
        },
        {
            key: 'averageScore',
            value: formatNormalizedAsPercent(headline.averageScoreNormalized),
            label: intl.formatMessage(i18nMessages.courseStatisticsAverageScore),
        },
    ]

    return (
        <div className={classes.strip}>
            {cards.map((card) => (
                <div className={classes.card} key={card.key}>
                    <Typography className={classes.value}>{card.value}</Typography>
                    <Typography className={classes.label}>{card.label}</Typography>
                </div>
            ))}
        </div>
    )
}

export default CourseStatsHeadlineStrip
